module.exports = __webpack_public_path__ + "img/About-01_Background.864e93c9.jpg";